import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DBRx } from 'db/schema/drugs';
import { RootState } from 'lib/store';

export interface PrescriptionSlice {
  selections: DBRx[];
}

export const initialState: PrescriptionSlice = {
  selections: [],
};

const prescriptionSlice = createSlice({
  initialState,
  name: 'prescription',
  reducers: {
    setPrescriptions: (state, action: PayloadAction<DBRx[]>) => {
      return {
        selections: action.payload,
      };
    },
    addPrescription: (state, action: PayloadAction<DBRx>) => {
      return {
        selections: [...state.selections, action.payload],
      };
    },
    removePrescription: (state, action: PayloadAction<DBRx>) => {
      return {
        selections: state.selections.filter((item) => {
          return item.id !== action.payload.id;
        }),
      };
    },
  },
});

const { actions, reducer } = prescriptionSlice;

export const { setPrescriptions, addPrescription, removePrescription } =
  actions;

export const selectNumberOfPrescriptions = (state: RootState) =>
  state.prescription.selections.length;

export const selectCurrentPrescriptions = (state: RootState): DBRx[] =>
  state.prescription.selections;

export default reducer;
